/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pencil': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M136 312L344 104 408 168 200 376z"/><path pid="1" d="M368 80L432 16 496 80 432 144z"/><path pid="2" d="M64 448L112 336 176 400z"/>'
  }
})
